import { LitElement, html } from './lit-all.min.js';
import NiceSelect from "./nice-select2.js";
import { Zones } from './sms-zones.js';

class LitElementEjected extends LitElement {
    createRenderRoot() {
        // Returning `this` will render the template directly into the light DOM
        return this;
    }
}

const sms = {
    form: null,
    zoneGroups: {
        "1": {
            "11/15-6/14": "spring",
            "6/15-11/14": "hotSummer",
        },
        "2": {
            "12/1-5/31": "spring",
            "6/1-7/15": "summer",
            "7/16-8/14": "hotSummer",
            "8/15-11/30": "fall",
        },
        "3": {
            "12/15-5/14": "spring",
            "5/15-7/15": "summer",
            "7/16-8/31": "hotSummer",
            "9/1-12/14": "fall",
        },
        "4": {
            "1/1-4/30": "spring",
            "5/1-6/30": "summer",
            "7/1-9/14": "hotSummer",
            "9/15-12/31": "fall",
        },
        "5": {
            "1/1-4/30": "spring",
            "5/1-6/30": "summer",
            "7/1-9/14": "hotSummer",
            "9/15-12/31": "fall",
        }
    },
    sizes: {
        "0-2000" : { 
            products: ["Velvet Green lawn Food x 1","Huma-Iron x 2","Huma-Iron x 2","Velvet Green lawn Food x 1"],
            icon: html`<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="24" viewBox="0 0 24 24" width="24"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="m16.0125 19.725h-13.2v1.5c0 .525.4125.9375.9375.9375h15.6"/><path d="m16.0125 19.725h-13.57499c-.7875 0-1.425-.6375-1.425-1.425v-.3c0-2.775 3.15-6.375 5.925-6.375h12.18749c.975 0 1.7625.7875 1.7625 1.7625v1.9875"/><path d="m19.3875 22.1625c1.9675 0 3.5625-1.595 3.5625-3.5625s-1.595-3.5625-3.5625-3.5625-3.5625 1.595-3.5625 3.5625 1.595 3.5625 3.5625 3.5625z"/><path d="m19.3875 20.2501c.9113 0 1.65-.7388 1.65-1.65 0-.9113-.7387-1.65-1.65-1.65s-1.65.7387-1.65 1.65c0 .9112.7387 1.65 1.65 1.65z"/><path d="m6.97504 11.5875 2.325 3.7125c.45.75 1.27496 1.2 2.17496 1.2h5.025"/><path d="m14.1 11.5875 1.725 2.9625"/><path d="m10.875 11.5875 1.725 2.9625"/><path d="m6 4.42502c3.45-3.449996 9.075-3.449996 12.5625 0"/><path d="m9.26251 6.07507c1.68749-1.6875 4.38749-1.6875 6.07499 0"/><path d="m12.3 9.26255c.5592 0 1.0125-.45331 1.0125-1.0125s-.4533-1.0125-1.0125-1.0125-1.0125.45331-1.0125 1.0125.4533 1.0125 1.0125 1.0125z"/></g></svg>`,
        },
        "2001-4000": { 
            products: ["Velvet Green Lawn Food x 2","Huma-Iron x 4","Huma-Iron x 4","Velvet Green Lawn Food x 2"],
            icon: html`<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="24" viewBox="0 0 24 24" width="24"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="m17.55 17.3251h-11.06245v2.8875h11.06245z"/><path d="m5.66252 23.2501h-1.3125c-.45 0-.825-.375-.825-.825v-5.9625c0-.45.375-.825.825-.825h1.3125c.45 0 .825.375.825.825v5.925c0 .4875-.375.8625-.825.8625z"/><path d="m3.52502 21.0375h-.6375c-.375 0-.675-.3-.675-.675v-1.8375c0-.375.3-.675.675-.675h.6375z"/><path d="m18.3376 23.2501h1.3125c.45 0 .825-.375.825-.825v-5.9625c0-.45-.375-.825-.825-.825h-1.3125c-.45 0-.825.375-.825.825v5.925c0 .4875.375.8625.825.8625z"/><path d="m20.475 21.0375h.6375c.375 0 .675-.3.675-.675v-1.8375c0-.375-.3-.675-.675-.675h-.6375z"/><path d="m8.625 20.2125v1.425"/><path d="m7.76257 21.6376h1.725"/><path d="m15.375 20.2125v1.425"/><path d="m14.5126 21.6376h1.725"/><path d="m12 20.2125v1.425"/><path d="m11.1376 21.6376h1.725"/><path d="m14.9625 17.325h-5.92502v-1.125c0-.7875.6375-1.3875 1.38752-1.3875h3.075c.7875 0 1.3875.6375 1.3875 1.3875v1.125z"/><path d="m9.41248 1.53748h.525c.90002 0 1.61252.7125 1.61252 1.6125v4.425"/><path d="m6.9375 17.325 4.35-6.1125c.15-.225.2625-.45.3-.7125"/><path d="m8.6625 2.28752h-2.4375c-.4125 0-.7875-.3375-.7875-.7875 0-.4125.3375-.787496.7875-.787496h2.4375c.4125 0 .7875.337496.7875.787496-.0375.45-.375.7875-.7875.7875z"/><path d="m12.4125 7.57498v-4.425c0-.9.7125-1.6125 1.6125-1.6125h.525"/><path d="m12.4501 10.5c.0375.2625.15.4875.3.7125l4.35 6.1125"/><path d="m15.3375 2.28752h2.4375c.4125 0 .7875-.3375.7875-.7875 0-.4125-.3375-.787496-.7875-.787496h-2.4375c-.4125 0-.7875.337496-.7875.787496.0375.45.375.7875.7875.7875z"/><path d="m12.5625 10.5001h-1.125c-.3375 0-.6-.2625-.6-.60003v-1.725c0-.3375.2625-.6.6-.6h1.125c.3375 0 .6.2625.6.6v1.725c0 .30003-.2625.60003-.6.60003z"/></g></svg>`,
        },
        "4001-6000": { 
            products: ["Velvet Green lawn Food x 3","Huma-Iron x 5","Huma-Iron x 5","Velvet Green lawn Food x 3"],
            icon: html`<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="24" viewBox="0 0 24 24" width="24"><circle cx="3.82507" cy="17.325" fill="currentColor" r=".375"/><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="m5.40002 16.725.9375-.225 9.22498-2.175 2.775-.675c.975-.225 1.875.4875 1.9125 1.4625"/><path d="m17.6625 19.9875h-11.88748"/><path d="m6.33752 16.4999.4875-3.15c.075-.5625.4875-.975 1.05-1.125l6.03748-1.35c.8625-.1875 1.65.45 1.65 1.3125v2.1375"/><path d="m3.41255 21.375c1.51188 0 2.7375-1.2256 2.7375-2.7375s-1.22562-2.7375-2.7375-2.7375-2.737501 1.2256-2.737501 2.7375 1.225621 2.7375 2.737501 2.7375z"/><path d="m3.41252 20.025c.7663 0 1.3875-.6212 1.3875-1.3875s-.6212-1.3875-1.3875-1.3875c-.76629 0-1.3875.6212-1.3875 1.3875s.62121 1.3875 1.3875 1.3875z"/><path d="m20.25 19.8c.8492 0 1.5375-.6884 1.5375-1.5375 0-.8492-.6883-1.5375-1.5375-1.5375-.8491 0-1.5375.6883-1.5375 1.5375 0 .8491.6884 1.5375 1.5375 1.5375z"/><path d="m20.2501 21.375c1.719 0 3.1125-1.3935 3.1125-3.1125s-1.3935-3.1125-3.1125-3.1125-3.1125 1.3935-3.1125 3.1125 1.3935 3.1125 3.1125 3.1125z"/><path d="m20.7 3.97498-1.8 4.1625c-.525 1.2-.7875 2.51252-.7875 3.86252v1.725"/><path d="m19.4626 3.71252-1.95 4.4625c-.525 1.2-.7875 2.54998-.7875 3.86248v2.025"/><path d="m22.5376 3.975h-2.5125c-.375 0-.675-.3-.675-.675s.3-.675.675-.675h2.5125c.375 0 .675.3.675.675s-.3.675-.675.675z"/><path d="m9.18752 13.2375-.225 1.575"/><path d="m11.0625 12.75-.225 1.575"/><path d="m12.9375 12.3-.225 1.575"/></g></svg>`,
        },
        "6001-8000": { 
            products: ["Velvet Green Lawn Food x 4","Huma-Iron x 7","Huma-Iron x 7","Velvet Green Lawn Food x 4"],
            icon: html`<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="24" viewBox="0 0 24 24" width="24"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="m19.0125 20.475h.9c.6 0 1.125-.4875 1.125-1.125v-2.775l-6.7125-.9-2.2125-.3c-.675-.075-1.2-.6-1.35-1.2375l-.225-1.05-.3375-1.5375c-.15-.75-.82502-1.275-1.57502-1.275h-6.15c-.825 0-1.500004.675-1.500004 1.4625v7.575c0 .6.487504 1.125 1.125004 1.125h1.1625"/><path d="m15.1875 20.4751h-6.33752"/><path d="m14.2875 15.675v-1.1625c0-.45.2625-.825.675-.9375l4.6875-1.575c.6375-.225 1.3125.2625 1.3125.9375v3.675"/><path d="m19.4625 3.33755h2.7c.4875 0 .8625-.375.8625-.8625s-.375-.8625-.8625-.8625h-2.7c-.4875 0-.8625.375-.8625.8625s.375.8625.8625.8625z"/><path d="m18.6 2.4751c-1.4625 0-2.8125.825-3.525 2.1l-4.5375 8.475"/><path d="m17.1 22.3875c1.0562 0 1.9125-.8563 1.9125-1.9125s-.8563-1.9125-1.9125-1.9125-1.9125.8563-1.9125 1.9125.8563 1.9125 1.9125 1.9125z"/><path d="m17.1 21.1876c.3935 0 .7125-.319.7125-.7125s-.319-.7125-.7125-.7125c-.3936 0-.7125.319-.7125.7125s.3189.7125.7125.7125z"/><path d="m6.03748 22.3501c1.65685 0 3-1.3431 3-3s-1.34315-3-3-3c-1.65686 0-3 1.3431-3 3s1.34314 3 3 3z"/><path d="m6.03748 20.6626c.72487 0 1.3125-.5876 1.3125-1.3125s-.58763-1.3125-1.3125-1.3125c-.72488 0-1.3125.5876-1.3125 1.3125s.58762 1.3125 1.3125 1.3125z"/><path d="m2.8125 10.275h5.325v-.75c0-.375-.3-.7125-.7125-.7125h-3.9c-.375 0-.7125.3-.7125.7125z"/><path d="m6.03748 12.0751v1.65"/><path d="m7.91248 12.0751v1.65"/><path d="m4.19995 12.0751v1.65"/></g></svg>`,
        },
        "8001-10000": { 
            products: ["Velvet Green Lawn Food x 5","Huma-Iron x 8","Huma-Iron x 8","Velvet Green Lawn Food x 5"],
            icon: html`<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="24" viewBox="0 0 24 24" width="24"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="m20.7 19.95c-1.4911 0-2.7-1.2088-2.7-2.7 0-1.4911 1.2089-2.7 2.7-2.7 1.4912 0 2.7 1.2089 2.7 2.7 0 1.4912-1.2088 2.7-2.7 2.7z"/><path d="m20.7 18.4876c-.6835 0-1.2375-.5541-1.2375-1.2375 0-.6835.554-1.2375 1.2375-1.2375s1.2375.554 1.2375 1.2375c0 .6834-.554 1.2375-1.2375 1.2375z"/><path d="m3.29998 18.4876c-.68346 0-1.2375-.5541-1.2375-1.2375 0-.6835.55404-1.2375 1.2375-1.2375.68345 0 1.2375.554 1.2375 1.2375 0 .6834-.55405 1.2375-1.2375 1.2375z"/><path d="m3.3 19.95c-1.49117 0-2.700001-1.2088-2.700001-2.7 0-1.4911 1.208831-2.7 2.700001-2.7s2.7 1.2089 2.7 2.7c0 1.4912-1.20883 2.7-2.7 2.7z"/><path d="m22.6125 15.3376v-4.4251c0-.6375-.525-1.19995-1.2-1.19995h-5.2125c-.6375 0-1.1625.52495-1.1625 1.16245v1.0125c0 .75-.6 1.3125-1.3125 1.3125h-2.4c-.75 0-1.3125-.6-1.3125-1.3125v-5.39995h-4.08745c-1.9125 0-3.6375 1.0125-4.6125 2.6625-.450001.7875-.712501 1.72495-.712501 2.62495v5.475"/><path d="m9.78757 19.5h5.21253c.45 0 .825-.375.825-.825v-1.425h-6.82503v1.425c0 .45.3375.825.7875.825z"/><path d="m18.0375 17.25h-12.07502"/><path d="m22.275 7.65005v-2.7c0-.4875-.4125-.9-.9-.9s-.9.4125-.9.9v2.1c0 .4875-.4125.9-.9.9h-2.8125c-.4875 0-.9.4125-.9.9s.4125.9.9.9h3.4125c1.1625 0 2.1-.9375 2.1-2.1z"/><path d="m9.97507 6.4876 1.16253-1.2"/><path d="m10.125 4.1626 1.9875 2.2125"/><path d="m9.97498 10.6875h-9.262503"/><path d="m6.9375 6.48755v4.19995"/></g></svg>`,
        },
        "10001-12000": { 
            products: ["Velvet Green Lawn Food x 6","Huma-Iron x 10","Huma-Iron x 10","Velvet Green Lawn Food x 6"],
            icon: html`<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="24" viewBox="0 0 24 24" width="24"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><path d="m9.56248 20.0625c1.32552 0 2.40002-1.0746 2.40002-2.4 0-1.3255-1.0745-2.4-2.40002-2.4-1.32549 0-2.4 1.0745-2.4 2.4 0 1.3254 1.07451 2.4 2.4 2.4z"/><path d="m9.56255 18.675c.55915 0 1.01245-.4533 1.01245-1.0125s-.4533-1.0125-1.01245-1.0125c-.55919 0-1.0125.4533-1.0125 1.0125s.45331 1.0125 1.0125 1.0125z"/><path d="m20.85 18.675c.5592 0 1.0125-.4533 1.0125-1.0125s-.4533-1.0125-1.0125-1.0125-1.0125.4533-1.0125 1.0125.4533 1.0125 1.0125 1.0125z"/><path d="m20.85 20.0625c1.3254 0 2.4-1.0746 2.4-2.4 0-1.3255-1.0746-2.4-2.4-2.4-1.3255 0-2.4 1.0745-2.4 2.4 0 1.3254 1.0745 2.4 2.4 2.4z"/><path d="m8.325 19.6875h-6.825c-.4125 0-.75-.3375-.75-.75 0-.225.075-.4125.225-.525.15-.15.3375-.225.525-.225h.4875 5.25"/><path d="m11.925 17.6625h6.5625"/><path d="m7.23755 18.1875h-5.25v-1.8c0-1.3875 1.125-2.5125 2.5125-2.5125h3.7125c.75 0 1.35-.6 1.35-1.35v-1.6125c0-.7125.56245-1.27505 1.27495-1.27505h8.625v-4.5c1.5 0 2.7 1.2 2.7 2.7v7.80005"/><path d="m14.1375 9.63748v-.9375c0-.4875.4125-.9.9-.9h2.625v-2.925c0-.4875.4125-.9.9-.9.2625 0 .4875.1125.6375.2625s.2625.375.2625.6375v4.8"/><path d="m10.9125 9.63745 1.0125-4.125"/><path d="m10.4625 5.51245h2.7375"/><path d="m13.2 11.6625v2.4"/><path d="m17.4375 11.6625v2.4"/><path d="m15.3 11.6625v2.4"/></g></svg>`,
        }
    },
    data: getFormData(),
}


function getFormData() {
    const input = document.querySelector('.sms-form-data');
    const data = input.dataset;

    // input.remove();
    return data;
}


class SMSForm extends LitElementEjected {
    static get properties() {
        return {
            state: { type: String },
            plan: { type: Object },
            product: { type: Object },
            quantity: { type: Number },
            variant: { type: Object },
            size: { type: String },
            zone: { type: String },
        };
    }

    constructor() {
        super();
        sms.form = this;
        this.state = 'loading';

        this.data = sms.data;
        this.date = new Date();
        this.settings = JSON.parse(this.data.settings);
        this.options = JSON.parse(sms.data.options);
        this.season = '';
        this.product = {}
        this.variant = {};
        this.plan = {};
        this.size = '';
        this.zone = '';
        this.updateSize = this.updateSize.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    
    connectedCallback() {
        super.connectedCallback();
        this.state = 'idle';
    }
    
    render() {
        return html`
            <div class="sms-form">
                ${this.zoneBlock()}
                <form class="sms-form" @submit=${this.handleSubmit}>
                    ${this.yardSizeBlock()}
                    ${this.buttonBlock()}
                </form>
            </div>
        `;
    }

    firstUpdated() {
        super.firstUpdated();
    }

    zoneBlock() {
        return html`
            <sms-zone-input
                .label=${this.settings.zip_label}
                .errorLabel=${this.settings.zip_error}
            ></sms-zone-input>
        `;
    }

    yardSizeBlock() {
        const { yard_size_label, measure_text, measure_link } = this.settings;
        const sizeOptions = this.options.find(option => option.name === 'Yard Size').values;

        return html`
            <div class="sms-form__block">
                <fieldset>
                    <legend class="sms-form__label">
                        ${yard_size_label}
                        ${measure_text && measure_link ? html`
                            <a class="sms-form__link" href="${measure_link}" target="_blank">${measure_text}</a>
                        ` : ''}
                    </legend>
                    <div class="sms-form__radios">
                        ${sizeOptions.map(option => this.yardSizeRadio(option, (option === this.size)))}
                    </div>
                </fieldset>
                <div class="sms-form__info">
                    ${sms.sizes[this.size] && this.zone ?
                        this.yardSizeExtras(sms.sizes[this.size])
                    : ''} 
                </div>
            </div>
        `;
    }

    yardSizeExtras() {
        return html`
            ${sms.sizes[this.size].products.map((item, i) => {
                var step = '';
                switch (i) {
                    case 0:
                        step = 'Spring';
                        break;
                    case 1:
                        step = 'Early Summer';
                        break;
                    case 2:
                        step = 'Summer';
                        break;
                    case 3:
                        step = 'Fall';
                        break;
                }
                return html`
                    <span class="sms-form__info-item">${step}: ${item}</span>
                `;
            })}
        `;
    }

    yardSizeRadio(option, checked) {
        return html`
            <label 
                class="sms-form__radio${checked ? ' sms-form__radio--checked' : ''}" 
                for="sms-yard-size-${option}"
            >
                <input 
                    type="radio" 
                    name="quantity" 
                    id="sms-yard-size-${option}" 
                    value="${option}" 
                    ?checked=${checked} 
                    @change=${this.updateSize} 
                />
                ${sms.sizes[option].icon}
                <span>${option}</span>
            </label>
            
        `;
    }

    buttonBlock() {
        const variantFound = Object.keys(this.variant).length > 0;
        return html`
            <div class="sms-form__block">
                <button 
                    class="sms-form__button"
                    type="submit"
                    ?disabled=${!variantFound || this.state === 'loading'}
                >
                    Subscribe ${variantFound ? this.priceEl() : ''}
                </button>
                <p class="sms-form__note">
                    Need more than 12000 sq ft? <a class="sms-form__link" href="/pages/contact-us">Contact Us</a> for a custom quote.
                </p>
            </div>
        `;
    }

    priceEl() {
        const price = Object.keys(this.plan).length > 0 ? this.plan.price : this.variant.price;
        
        const formattedPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(price / 100);

        return html`
            <span class="sr-only">for</span> (${formattedPrice})
        `;
    }

    updateZone(zone) {
        try {
            this.zone = zone;

            if (this.zone === '' && this.size === '') {
                this.product = {};
                this.variant = {};
                this.plan = {};
                return;
            }

            this.getProduct();
        } 
        catch (error) {
            console.error('Error updating zone:', error);
        }
        
    }
    
    updateSize(event) {
        this.size = event.target.value;
    
        try {
            if (this.size === '' || this.zone === '') {
                this.variant = {};
                this.plan = {};
                return;
            } else if (this.product && this.product.variants.length > 0) {
                this.updateVariant();
            }
        }
        catch (error) {
            console.error('Error updating size:', error);
        }
    }
    
    getProduct() {
        try {
            let zoneGroup = false;
            switch (this.zone) {
                case '1': case '2':
                    zoneGroup = sms.zoneGroups['1'];
                    break;
                case '3': case '4': case '5':
                    zoneGroup = sms.zoneGroups['2'];
                    break;
                case '6': case '7': case '8':
                    zoneGroup = sms.zoneGroups['3'];
                    break;
                case '9':
                    zoneGroup = sms.zoneGroups['4'];
                    break;
                case '10': case '11': case '12':
                    zoneGroup = sms.zoneGroups['5'];
                    break;
            }

            if (!zoneGroup) {
                return;
            }

            this.season = this.getSeason(zoneGroup);
            this.product = JSON.parse(this.data[zoneGroup[this.season]]);
            this.updateVariant();
        }
       catch (error) {
            console.error('Error updating product:', error);
        }
    }

    getSeason(zoneGroup) {
        const currentMonth = this.date.getMonth() + 1; // Months are 0-indexed
        const currentDay = this.date.getDate();
    
        return Object.keys(zoneGroup).find(range => {
            const [start, end] = range.split('-');
            const [startMonth, startDay] = start.split('/').map(Number);
            const [endMonth, endDay] = end.split('/').map(Number);
    
            const isInRange = (month, day) => {
                if (startMonth < endMonth || (startMonth === endMonth && startDay <= endDay)) {
                    // Normal range within the same year
                    return (
                        (month > startMonth || (month === startMonth && day >= startDay)) &&
                        (month < endMonth || (month === endMonth && day <= endDay))
                    );
                } else {
                    // Range spans across the year boundary
                    return (
                        (month > startMonth || (month === startMonth && day >= startDay)) ||
                        (month < endMonth || (month === endMonth && day <= endDay))
                    );
                }
            };
    
            return isInRange(currentMonth, currentDay);
        });
    }

    updateVariant() {
        if (this.zone === '' || this.size === '') {
            this.variant = {};
            return;
        }

        this.variant = this.product.variants.find(variant => {
            return variant.option1 === this.zone && variant.option2 === this.size;
        });

        this.plan = this.variant.selling_plan_allocations.length > 0 ? this.variant.selling_plan_allocations[0] : {};
    }

    async handleSubmit(event) {
        event.preventDefault();

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'id': this.variant.id,
                'quantity': 1,
                'selling_plan': this.plan.selling_plan_id
            })
        })
        .then(response => {
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}
customElements.define('sms-form', SMSForm);

class SMSSelect extends LitElementEjected {
    static properties = {
        options: { type: Array },
        value: { type: String },
        label: { type: String }
    }

    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
    }

    render() {
        return html`
            <div class="sms-select__wrapper">
                <label for="sms-select" class="sms-form__label">${this.label}</label>
                <div class="sms-select">
                    <select tabindex="-1" id="sms-select" style="display: none;" name="properties[zone]" @change=${this.handleChange}>
                        ${this.options.map(option => this.option(option))}
                    </select>
                </div>
            </div>
        `;
    }

    firstUpdated() {
        super.firstUpdated();
        this.select = this.renderRoot.querySelector('select');
        new NiceSelect(this.select, {searchable: true, placeholder: "Select a Zip Code"});
    }

    optionGroup(group) {
        return html`
             <optgroup label="${group.name}">
                ${group.items.map(option => this.option(option))}
            </optgroup>
        `;
    }

    option(option) {
        const value = `${option[0]} - Hardiness Zone ${option[1]}`;

        return html`
            <option value="${value}">${value}</option>
        `;
    }

    handleChange(e) {
        sms.form.zone = e.target.value;
    }
}
customElements.define('sms-select', SMSSelect);

class SMSZoneInput extends LitElementEjected {
    static properties = {
        options: { type: Object },
        value: { type: String },
        label: { type: String },
        zone: { type: String }
    }

    constructor() {
        super();
        this.value = '';
        this.options = Zones;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.resetInput = this.resetInput.bind(this);
    }

    render() {
        return html`
            <div class="sms-input__wrapper sms-form">
                ${this.zone === 'error' ? 
                    this.errorBlock() : 
                    this.contentBlock()
                }
            </div>
        `;
    }

    firstUpdated() {
        super.firstUpdated();
    }

    contentBlock() {
        return html`
            ${this.zone ?
                this.zoneBlock() :
                this.inputBlock()
            }
        `;
    }

    zoneBlock() {
        return html`
            <span class="sms-form__label">${this.label}</span>
            <div class="sms-form__row">
                <p class="sms-form__text text--zone">
                    ${this.zone.split(' : ')[0]}
                    (hardiness ${this.zone.split(' : ')[1]})
                </p>
                <button 
                    class="sms-form__button" 
                    type="button"
                    @click=${this.resetInput}
                >
                    Edit
                </button>
            </div>
        `;
    }

    errorBlock() {
        return html`
            <span class="sms-form__label">${this.label}</span>
            <div class="sms-form__row">
                <p class="sms-form__text text--error">
                    ${this.errorLabel}
                </p>
                <button 
                    class="sms-form__button" 
                    type="button" 
                    @click=${this.resetInput}
                >
                    Try Again
                </button>
            </div>
        `
    }


    inputBlock() {
        return html`
            <label 
                for="sms-zone-input" 
                class="sms-form__label"
            >
                ${this.label}
            </label>
            <div class="sms-input sms-form__row">
                <input id="sms-zone-input" 
                    type="search" 
                    pattern="[0-9]{5}"
                    placeholder="Enter your zipcode"
                    @change=${this.handleChange}
                    ?disabled=${!this.options}
                    value=${this.value}
                />
                <button
                    class="sms-form__button"
                    type="submit"
                    @click=${this.handleSubmit}
                >
                    Submit
                </button>
            </div>
        `;
    }

    resetInput() {
        this.zone = '';
        this.value = '';
        sms.form.updateZone();
    }

    handleChange(event) {
        this.value = event.target.value;
    }

    handleSubmit(event) {
        event.preventDefault();
        const zone = this.options[this.value];

        if (zone) {
            this.zone = `${this.value} : ${zone}`;
            sms.form.updateZone(zone);
        } else {
            this.zone = 'error';
            sms.form.updateZone();
        }
    }
}
customElements.define('sms-zone-input', SMSZoneInput);